export default __webpack_public_path__ + "static/kfa-logo-afad409a1cbbc4c3fab595cf7d678afd.png";